import React from 'react';
import { UserStatistics } from '../../../types/user';
import styles from '../AdminPanel.module.css';
import { MdPeople, MdStar, MdAdminPanelSettings, MdTrendingUp, MdPersonAdd } from 'react-icons/md';

// Basit bir grafik bileşeni
const BarChart = ({ data }: { data: {month: string; count: number}[] }) => {
  const maxValue = Math.max(...data.map(item => item.count));
  
  return (
    <div className={styles.barChart}>
      {data.map((item, index) => (
        <div key={index} className={styles.barChartItem}>
          <div className={styles.barChartBar}>
            <div 
              className={styles.barChartFill} 
              style={{ height: `${(item.count / maxValue) * 100}%` }}
            ></div>
          </div>
          <div className={styles.barChartLabel}>{item.month}</div>
          <div className={styles.barChartValue}>{item.count}</div>
        </div>
      ))}
    </div>
  );
};

interface DashboardProps {
  stats: UserStatistics | null;
}

const Dashboard: React.FC<DashboardProps> = ({ stats }) => {
  if (!stats) {
    return <div>Yükleniyor...</div>;
  }

  return (
    <div>
      <h2>Gösterge Paneli</h2>
      
      <div className={styles.statsGrid}>
        <div className={styles.statCard}>
          <div className={styles.statIcon}><MdPeople /></div>
          <div className={styles.statValue}>{stats.totalUsers}</div>
          <div className={styles.statLabel}>Toplam Kullanıcı</div>
        </div>
        
        <div className={styles.statCard}>
          <div className={styles.statIcon}><MdTrendingUp /></div>
          <div className={styles.statValue}>{stats.activeUsers}</div>
          <div className={styles.statLabel}>Aktif Kullanıcı</div>
        </div>
        
        <div className={styles.statCard}>
          <div className={styles.statIcon}><MdStar /></div>
          <div className={styles.statValue}>{stats.premiumUsers}</div>
          <div className={styles.statLabel}>Premium Kullanıcı</div>
        </div>
        
        <div className={styles.statCard}>
          <div className={styles.statIcon}><MdAdminPanelSettings /></div>
          <div className={styles.statValue}>{stats.adminUsers}</div>
          <div className={styles.statLabel}>Yönetici</div>
        </div>
      </div>
      
      <div className={styles.cardSection}>
        <h3>Son 30 Günde Kaydolan Kullanıcılar</h3>
        <div className={styles.statValueLarge}>{stats.newUsersLast30Days}</div>
        <p>Son ayda kaydolan kullanıcı sayısı</p>
      </div>
      
      <div className={styles.cardSection}>
        <h3>Kullanıcı Artış Grafiği</h3>
        <BarChart data={stats.usersByMonth} />
      </div>
      
      <div className={styles.cardSection}>
        <h3>Kullanıcı Rollerine Göre Dağılım</h3>
        <div className={styles.pieChart}>
          {stats.usersByRole.map((item, index) => (
            <div key={index} className={styles.pieChartItem}>
              <div className={styles.pieChartValue}>{item.count}</div>
              <div className={styles.pieChartLabel}>{item.role === 'admin' ? 'Yönetici' : 'Kullanıcı'}</div>
            </div>
          ))}
        </div>
      </div>
      
      <div className={styles.cardSection}>
        <h3>Hızlı Eylemler</h3>
        <div className={styles.quickActions}>
          <button className={styles.quickActionButton}>
            <MdPersonAdd className={styles.quickActionIcon} />
            <span>Yeni Kullanıcı Ekle</span>
          </button>
          
          <button className={styles.quickActionButton}>
            <MdAdminPanelSettings className={styles.quickActionIcon} />
            <span>Yönetici Ata</span>
          </button>
          
          <button className={styles.quickActionButton}>
            <MdStar className={styles.quickActionIcon} />
            <span>Premium Kullanıcı Ekle</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
